export default "__VITE_ASSET__BHjW1WYY__"